import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from 'axios';
import { useNavigate } from "react-router-dom";

import LoginModal from "./LoginModal";
import RecoverPasswordModal from "./RecoverPasswordModal";
import RegisterModal from "./RegisterModal";
import logo1 from "./../components/assets/images/ADELPHI UNI.png";
import logo2 from "./../components/assets/images/oldwestbury.jpg";
const endPoint = "https://azebrahimi.eastus.cloudapp.azure.com/api/";

const Header = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);
  const [isRecoverPasswordOpen, setIsRecoverPasswordOpen] = useState(false);

  useEffect(() => {
    const storedUserData = localStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  const handleLogout = () => {
    // localStorage.removeItem("userData");
    navigate("/");
    localStorage.clear();
    toastSuccess("User logged out successfully.");
    setUserData(null);
    window.location.reload();
  };
  const openChangePassword = async () => {
    Swal.fire({
      title: "Change Password",
      html: `
        <input type="email" id="swal-input-email" class="swal2-input" placeholder="Your email">
        <input type="password" id="swal-input-new-password" class="swal2-input" placeholder="New password">
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Change Password",
      showLoaderOnConfirm: true, // Show loader during request
      allowOutsideClick: false, // Prevent modal from closing on outside click
      preConfirm: async () => {
        const email = document.getElementById("swal-input-email").value;
        const newPassword = document.getElementById("swal-input-new-password").value;
  
        // Validation
        if (!email || !newPassword) {
          Swal.showValidationMessage("Both fields are required.");
          return null;
        }
       const token = localStorage.getItem("token")
        try {
          // Send the email and new password to the backend
          const response = await axios.post(`${endPoint}Security/reset-password`, {
            email,
            newPassword,
            token
          }, {
            headers: {
                'accept': '*/*',
                'Authorization': `Bearer ${token}`, // Include the token here
            },
        });
  
          console.log(response.data);
          // Notify success
          Swal.fire("Password Changed", "Your password has been successfully updated.", "success");
        } catch (error) {
          Swal.showValidationMessage(
            error.response?.data?.message || "Failed to change password. Please try again."
          );
          console.error("Change password failed:", error);
        }
      },
    });
  };
  
  const openLogin = async () => {
   Swal.fire({
      title: "Login",
      html: `
        <input type="text" id="swal-input-email" class="swal2-input" placeholder="Your user name">
        <input type="password" id="swal-input-password" class="swal2-input" placeholder="Your password">
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Login",
      showLoaderOnConfirm: true, // Show loader during login
      allowOutsideClick: false, // Prevent modal from closing on outside click
      preConfirm: async () => {
        const email = document.getElementById("swal-input-email").value;
        const password = document.getElementById("swal-input-password").value;  
      if (!email || !password) {
        Swal.showValidationMessage("Please fill in both fields.");
        return null;
      }

      try {
        const response = await axios.post(`${endPoint}Security/login`, {
          userName: email,
          password,
        });
        console.log(response.data);
        debugger
        // Save user data and token to localStorage
        localStorage.setItem("userData", JSON.stringify(response.data));
        localStorage.setItem("token", response.data.token);

        // Close the modal and show success message
        // Swal.close(); // Explicitly close the modal
        Swal.fire("Login Successful", `Welcome, ${email}!`, "success");  
        // Reset form and refresh the page
       setTimeout(() => {
        window.location.reload();
       }, 1000);
      } catch (error) {
        Swal.showValidationMessage("Login Failed Invalid email or password. Please try again.")
        console.error("Login failed:", error);
      }
    },
  });
  };
  

  const toastSuccess = (title, text = "")=> {
    Swal.fire({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 4000,
        title: title,
        text: text,
        icon: 'success',
        timerProgressBar: true
    });
}
// const toastError = (title, text = "")=> {
//     Swal.fire({
//         toast: true,
//         position: 'top-end',
//         showConfirmButton: false,
//         timer: 4000,
//         title: title,
//         text: text,
//         icon: 'error',
//         timerProgressBar: true
//     });
// }

    const openRegister = async () => {
      await Swal.fire({
        title: "Register Here",
        html: `
            <input type="text" id="swal-input-username" class="swal2-input" placeholder="Your user name...">
            <input type="email" id="swal-input-email" class="swal2-input" placeholder="Your email address...">
            <input type="password" id="swal-input-password" class="swal2-input" placeholder="Your password...">
            <input type="password" id="swal-input-confirm-password" class="swal2-input" placeholder="Confirm password...">
            <mark style="font-size:14px">Passwords must be 6+ chars, include a symbol, a lowercase, and an uppercase letter. i.e Ex@mple1!</mark>
        `,
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Register",
        showLoaderOnConfirm: true,
        allowOutsideClick: false,
        preConfirm: async () => {
          const userName = document.getElementById("swal-input-username").value;
          const email = document.getElementById("swal-input-email").value;
          const password = document.getElementById("swal-input-password").value;
          const confirmPassword = document.getElementById("swal-input-confirm-password").value;
    
          // Client-side validation
          if (!userName || !email || !password || !confirmPassword) {
            Swal.showValidationMessage("Please fill in all fields.");
            return null;
          }
    
          if (password !== confirmPassword) {
            Swal.showValidationMessage("Passwords do not match.");
            return null;
          }
    
          // Server-side validation and registration
          try {
            const response = await axios.post(`${endPoint}Security/register`, {
              userName,
              email,
              password,
            });
    
            console.log(response.data);
    
            // Close modal on success
            Swal.fire("Registration Successful", `Welcome, ${userName}!`, "success");
          } catch (error) {
            // Stay open and display the error
            if(error.response && error.response.data.length){
              Swal.showValidationMessage(
                error.response.data[0].description
              );
            }
           else{
            Swal.showValidationMessage(
              "Registration failed. Please try again or check your details."
            );
           }
            console.error("Registration failed:", error);
            return null;
          }
        },
      });
    };
    

  const openRecoverPassword = () => {
    setIsRecoverPasswordOpen(true);
    setIsLoginOpen(false);
    setIsRegisterOpen(false);
  };

  return (
    <header className="header bg">
      <div className="header_top">
        <div className="container-fluid">
          <div className="contact_nav">
            <span style={{visibility:'hidden'}}>test</span>
            <span style={{ float: "right",clear:"both" }}>
              {!userData ? (
                <>
                  <a
                    style={{ fontSize: "100%",background:"#e3dddd",color:"white",border:"1px solid gray" }}
                    className="badge pointer text-white"
                    onClick={openLogin}
                    data-toggle="modal"
                  >
                    Login
                  </a>
                  {/* <span className="text-dark"> | </span> */}
                  {/* <a
                    style={{ fontSize: "100%" }}
                    className="badge badge-info pointer"
                    onClick={openRegister}
                    data-toggle="modal"
                  >
                    Register
                  </a> */}
                </>
              ) : (
                <>
                <div class="btn-group" style={{ float: "right", }}>
                <button style={{ fontSize: "100%",background:"#e3dddd",color:"white",border:"1px solid gray" }}  type="button" class="badge dropdown-toggle dropleft" data-toggle="dropdown" aria-expanded="false">
                {userData.userName} 
                </button>
                <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg-left">
                  <a class="dropdown-item" onClick={handleLogout}>Log Out</a>
                  <a class="dropdown-item" onClick={openChangePassword}>Change Password</a>
                </div>
              </div>
                </>
              )}
            </span>
            {userData && (

              <>

              </>
              // <span
              //   style={{ fontSize: "100%" }}
              //   className="badge badge-danger pointer"
              //   onClick={handleLogout}
              // >
              //   Log Out
              // </span>
            )}
          </div>
        </div>
      </div>
      <div className="header-cont text-white">
        <div className="row align-items-center justify-content-between">
          <div className="col-sm-6 text-left d-flex align-items-center justify-content-start">
          <a href="https://www.adelphi.edu/" target="_blank"><img src={logo1} alt="logo" className="mr-5 logo_1 hide_logo" /></a>
            <a href="https://www.oldwestbury.edu/" target="_blank">  <img src={logo2} alt="logo" className="ml-5 logo_1" /> </a>
          </div>
          <div className="col-sm-4 text-center">
            <a className="navbar-brand" href="/">
              <h1>Dr. Alireza Ebrahimi</h1>
            </a>
          </div>
          <div className="col-sm-1"></div>
        </div>
      </div>
      {/* <LoginModal
        show={isLoginOpen}
        onClose={() => setIsLoginOpen(false)}
        onOpenRegister={openRegister}
        onOpenRecoverPassword={openRecoverPassword}
      />
      <RegisterModal
        show={isRegisterOpen}
        onClose={() => setIsRegisterOpen(false)}
        onOpenLogin={openLogin}
      />
      <RecoverPasswordModal
        show={isRecoverPasswordOpen}
        onClose={() => setIsRecoverPasswordOpen(false)}
        onOpenLogin={openLogin}
      /> */}
    </header>
  );
};

export default Header;
